﻿<div class="route-component">
    <tab-control>
        <tab-page title="Details" icon="fas fa-user-pen">
            <div class="form-component">
                <h4 *ngIf="policyGroupId > 0">
                    Edit policy group
                </h4>

                <h4 *ngIf="policyGroupId === 0">
                    Create new policy group
                </h4>

                <form #form="ngForm" (ngSubmit)="onSave(form)">
                    <div class="input-group">
                        <label for="groupName">
                            Policy group name:<span class="required"> * </span>
                        </label>
                        <div>
                            <input name="groupName" #groupName="ngModel" type="text" placeholder="Group Name" [class.invalid]="groupName.invalid" [(ngModel)]="policyGroup.name" required>
                            <div *ngIf="groupName.invalid">
                                <span class="error">Name is required</span>
                            </div>
                        </div>
                    </div>

                    <div class="action-bar">
                        <button type="submit" class="button" [disabled]="form.invalid || isSaving">
                            <span *ngIf="isSaving" class="loading-spinner"></span>
                            <i *ngIf="!isSaving" class="fas fa-save"></i>
                            Save
                        </button>
                        <button type="button" class="button-cancel" (click)=" onCancel()">
                            <i class="fas fa-cancel"></i> Cancel
                        </button>
                    </div>
                </form>
            </div>
        </tab-page>
        <tab-page *ngIf="policyGroupId > 0" title="Policies" icon="fas fa-book">
            <div class="search-component">
                <h4>Policies in group</h4>

                <div class="search-bar">
                    <div class="search-bar left">
                        <div class="search-container">
                            <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="search" (keydown.enter)="getPoliciesForGroup(paging)">
                            <button class="search-button" (click)="getPoliciesForGroup(paging)">
                                <i class="fas fa-magnifying-glass"></i>
                            </button>
                        </div>
                    </div>
                    <div class="action-bar right">
                        <div class="action-container">
                            <button (click)="openAddPolicyDialog()">
                                Manage <i class="fas fa-cog"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <pageable-table
                    [items]="groupPolicies"
                    [paging]="paging"
                    [columns]="getColumnMap()"
                    (refreshData)="getPoliciesForGroup($event)">
                </pageable-table>
            </div>
        </tab-page>
    </tab-control>
</div>

<side-panel [isVisible]="isAddVisible" [caption]="panelCaption" (onDone)="onSidePanelDone()" (onCancel)="onSidePanelCancel()">

    <div class="sidebar">
        <div class="search-container">
            <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="search" (keydown.enter)="getAvailablePolicies()">
            <button class="search-button" (click)="getAvailablePolicies()">
                <i class="fas fa-magnifying-glass"></i>
            </button>
        </div>

        <div class="policy-list">
            <div *ngFor="let policy of availablePolicies" class="policy-item">
                <switch-control
                    name="isSelected-{{ policy.policyNumber }}"
                    [(ngModel)]="policy['isSelected']"
                    [label]="policy.clientName + ' (' + policy.policyNumber + ')'">
                </switch-control>
            </div>
        </div>
    </div>

</side-panel>